export default {
  props: {
    sLabel: {
      type: String,
      default: ''
    },
  },

}